import { Injectable } from "@angular/core";
import { InventoryAdditionalProperties, InventoryEntityField, InventoryResourceKnownRelation } from "src/app/models/api/inventoryResource.model";
import { LabelsProviderPipe } from "src/app/pipes/labels-provider/labels-provider.pipe";

@Injectable({
    providedIn: "root",
})
export class DisplayNameService {
    private _notAvailableString: string;
    private _identityTypeSystemString: string;

    constructor(labelsProviderPipe: LabelsProviderPipe) {
        this._notAvailableString = labelsProviderPipe.transform("common.notAvailable");
        this._identityTypeSystemString = labelsProviderPipe.transform("identityTypes.system");
    }

    /**
     * Get the display name of the user who created the resource
     * @param createdBy Identity which created the resource
     * @param additionalProperties Additional properties of the resource
     * @returns The display name of the user who created the resource
     */
    public getCreatedByDisplayName(
        createdBy: InventoryEntityField<InventoryResourceKnownRelation> | undefined,
        additionalProperties: InventoryAdditionalProperties | undefined,
    ): string {
        const SYSTEM_IDENTITY = "system";
        if (createdBy?.value?.displayName) {
            return createdBy.value.displayName;
        }

        if (additionalProperties?.["creatorIdentityType"] === SYSTEM_IDENTITY) {
            return this._identityTypeSystemString;
        }

        return this._notAvailableString;
    }
}
